// To book › Find a lead (BL-092): when it searches, and how it counts what it found.

export type SearchStatus = 'all' | 'open' | 'booked' | 'closed';

/** It searches once two characters are typed, or when only leads from an ad are asked for. */
export function searchAsked(q: string, fromAds: boolean): boolean {
  const t = q.trim();
  return fromAds || t.length >= 2;
}

/** "8 leads", "Showing 25 of 140 leads", "No lead has that". */
export function searchCount(total: number, shown: number): string {
  if (!total) return 'No lead has that.';
  const leads = `${total} ${total === 1 ? 'lead' : 'leads'}`;
  return shown < total ? `Showing ${shown} of ${leads}` : leads;
}
